import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { withStyles } from "@material-ui/core/styles"

import Header from "./header"
import Footer from "./footer"
import Sidebar from "./sidebar"
// import FooterPopup from "./footer-popup"
import FooterBannerPopup from "./footer-banner-popup"
import CenterPopup from "./center-popup"
import NotificationModal from "./notification-modal"

import "../../css/index.css"
import { DEPARTMENTS, INDUSTRIES } from "../../constants/constants"
import classNames from "classnames"

const styles = theme => ({
  title: {
    fontSize: "32px",
    textAlign: "center",
    fontWeight: "bold",
    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
    },
  },

  section: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px #254E781A",
    position: "relative",
  },

  contents: {
    padding: "30px 40px",
    [theme.breakpoints.down("xs")]: {
      padding: "30px",
    },
  },

  listTitle: {
    paddingBottom: "20px",
  },

  listContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    boxSizing: "border-box",
    background: "#FFFFFF",
    padding: "0",
    margin: "0",
  },

  listItem: {
    listStyle: "none",
    width: "33.33%",
    "& a": {
      fontSize: "12px",
      color: "#71737B",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },

    [theme.breakpoints.between("xs", "sm")]: {
      width: "50%",
    },

    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },

  link: {
    fontSize: "15px",
    fontWeight: "bold",
    textDecoration: "none",
    height: "unset",
    padding: "2px 4px",
    color: "inherit",

    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
  },
})

class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showSidebar: false,
      // showFooterPopup: false, //非表示のためコメントアウト
      // footerPopupDisplayed: false, // FooterPopup がすでにスクロールトリガーで表示されたかどうか
      showFooterBannerPopup: false,
      showCenterPopup: false,
      showNotificationModal: false,
    }
  }

  checkDevice = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    // スマホ、PCを判定する
    if (ua.indexOf('mobile') > 0 && (ua.indexOf('iphone') > 0 || ua.indexOf('ipod') > 0 || ua.indexOf('android') > 0)) {
        return 'mobile';
    } else if (ua.indexOf('ipad') > 0 || ua.indexOf('android') > 0) {
        // iOS12 まで
        return 'mobile';
    } else if ( 'ontouchend' in document && (ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1)) {
        // iOS13 以降
        return 'mobile';
    } else {
      return 'pc';
    }
  };

  isDisplayWidthRange = () => {
    // index.cssで、windowサイズが450px以下はwidth100%でfooterのpopupを表示してるので、450px未満であれば表示と判定する
    return window.innerWidth < 450;
  }

  componentDidMount() {
    const device = this.checkDevice();
    const isDisplayWidthRange = this.isDisplayWidthRange();

    // スマホの場合かつウインドウサイズが規定幅以下の場合、時間経過でフッターバナーを表示する
    if (device === 'mobile' && isDisplayWidthRange) {
      setTimeout(() => {
        this.setState({
          showFooterBannerPopup: true,
        })
      }, 5000);

    // PCの場合、時間経過でポップアップを表示する
    } else {
      if (!!document) document.addEventListener("scroll", this.handleScroll)

      this.timeout = setTimeout(() => {
        let showCenterPopup = JSON.parse(
          sessionStorage.getItem("showCenterPopup")
        )

        if (showCenterPopup === null) {
          sessionStorage.setItem("showCenterPopup", true)

          this.setState({
            showCenterPopup: true,
          })
        }
      }, 5000)
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
    if (!!document) document.removeEventListener("scroll", this.handleScroll)
  }

  openSidebar = () => {
    this.setState({ showSidebar: true })
  }

  closeSidebar = () => {
    this.setState({ showSidebar: false })
  }

  toggleCenterPopup = () => {
    sessionStorage.setItem("showCenterPopup", false)
    this.setState({
      showCenterPopup: false,
    })
  }

  toggleFooterBannerPopup = () => {
    this.setState({ showFooterBannerPopup: !this.state.showFooterBannerPopup })
  }

  // toggleFooterPopup = () => {
  //   this.setState({ showFooterPopup: !this.state.showFooterPopup })
  // }

  toggleNotificationModal = () => {
    this.setState({ showNotificationModal: !this.state.showNotificationModal })
  }

  handleScroll = () => {
    if (
      !!window &&
      !this.state.footerPopupDisplayed &&
      !this.state.showFooterPopup &&
      window.pageYOffset > 50
    ) {
      // this.setState({
      //   showFooterPopup: true,
      //   footerPopupDisplayed: true,
      // })
    }
  }

  render() {
    const { classes, hasFooterBannerPopup } = this.props
    return (
      <div className="root">
        <Header toggleSidebar={this.openSidebar} />
        <div className="main">{this.props.children}</div>

        <div className={classes.title} >その他の決裁者から探す</div>
        <div className={classNames(classes.section, "container")} style={{ marginTop: "15px" }}>
          <div className={classes.contents} >
            <h2 className={classNames(classes.listTitle, "title")} style={{ marginBottom: "0px" }}>
              部門から探す
            </h2>
            <ul className={classes.listContainer}>
              {DEPARTMENTS.map((item, i) => (
                <li className={classes.listItem} key={i}>
                  <Link key={i} to={`/departments/${item.value}`}>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={classNames(classes.section, "container")} style={{ margin: "40px auto 100px" }}>
          <div className={classes.contents} >
            <h2 className={classNames(classes.listTitle, "title")} style={{ marginBottom: "0px" }}>
              業界から探す
            </h2>
            <ul className={classes.listContainer}>
              {INDUSTRIES.map((item, i) => (
                <li className={classes.listItem} key={i}>
                  <Link key={i} to={`/industries/${item.value}`}>
                    {item.value}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Footer />
        <Sidebar
          open={this.state.showSidebar}
          toggleSidebar={this.closeSidebar}
        />
        <CenterPopup
          showPopup={this.state.showCenterPopup}
          togglePopup={this.toggleCenterPopup}
        />
        <FooterBannerPopup
          showPopup={this.state.showFooterBannerPopup}
          pageHasPopup={hasFooterBannerPopup}
          togglePopup={this.toggleFooterBannerPopup}
        />
        {/* <FooterPopup
          showPopup={this.state.showFooterPopup}
          pageHasPopup={hasFooterPopup}
          togglePopup={this.toggleFooterPopup}
        /> */}
        <NotificationModal
          open={this.state.showNotificationModal}
          onClose={this.toggleNotificationModal}
        />
      </div>
    )
  }
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
  // hasFooterPopup: false,
  hasFooterBannerPopup: true
}

export default withStyles(styles)(Layout)
